export type UiLocale = 'en' | 'de';

export const LOCALE_STORAGE_KEY = 'aleno_ops_locale_v1';

export function normalizeLocale(raw: string | null | undefined): UiLocale {
  if (!raw) return 'en';
  const lower = raw.toLowerCase();
  if (lower === 'de' || lower.startsWith('de-')) return 'de';
  return 'en';
}

export function detectBrowserLocale(): UiLocale {
  if (typeof navigator === 'undefined') return 'en';
  return normalizeLocale(navigator.language || navigator.languages?.[0]);
}

export function loadLocale(): UiLocale {
  if (typeof window === 'undefined') return 'en';
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored) return normalizeLocale(stored);
  } catch {
    /* ignore quota / private mode */
  }
  return detectBrowserLocale();
}

export function saveLocale(locale: UiLocale): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* ignore quota / private mode */
  }
}

/** BCP 47 tag for speech recognition. */
export function speechLocale(locale: UiLocale): string {
  return locale === 'de' ? 'de-DE' : 'en-US';
}

/** Dates and weekday names follow the UI language; numbers stay Swiss. */
export function dateLocale(locale: UiLocale): string {
  return locale === 'de' ? 'de-CH' : 'en-GB';
}

export const NUMBER_LOCALE = 'de-CH';
